// import axios from 'axios';
import $, { data } from 'jquery'
import RuntimeUtils from 'src/common/js/runtimeUtils'
import { $get, $post } from 'src/utils/httpUtil'
import { analysisFileType } from './commonUtils'

// 判断任务类型
export const JOB_STATUS = {
  job_status_aborted: '异常退出',
  job_status_busy: '正在转换',
  job_status_queued: '排队等候',
  job_status_complete: '完成转换',
}

// 转换配置参数
export const CONVERT_CONFIG_KEY = {
  '-viewname': '视图名称',
  '-shadetype': '着色类型',
  '-lod': '详细等级',
  '-assembly': '合并零件为构件',
  '-noedgeline': '不导出边线数据',
  '-recalcuv': '重新计算UV',
  '-mergevertex': '执行顶点合并',
}

export const CONVERT_CONFIG_VALUE = {
  default: '默认',
  custom: '自定义',
  shaded: '着色',
  realistic: '真实',
  rough: '粗略',
  medium: '中等',
  detail: '详细',
}

// 查询jobtype相关的配置数据，所有的文件转换类型
export const getConverterTypes = () =>
  new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/translation/v3/convertertypes`
    $get(url)
      .then((res) => {
        const converters = JSON.parse(JSON.stringify(res).toLowerCase())
        resolve(converters)
      })
      .catch((res) => {
        reject(res)
      })
  })

// 查询job的状态
// urn:bimbox.object:bucketKey/objectKey
export const getAllJobStatus = (bucket_key, seedList) =>
  new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/jobs/batchget`
    const data = seedList.map((ele) => `urn:bimbox.object:${bucket_key}/${ele.fileName}`)
    $post(url, data).then((res) => {
      resolve(res)
    })
  })
export const newGetAllJobStatus = (bucket_key, seedList) =>
  new Promise((resolve, reject) => {
    if (seedList != undefined) {
      const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/jobs/states`
      const seeds = seedList.map((ele) => `urn:bimbox.object:${bucket_key}/${ele.fileName}`)
      const data = {
        seeds,
      }
      $post(url, data)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    } else {
      resolve(null)
    }
  })
// 查看LOD转换任务状态 20210329 by wyx
export const getJobStatusForLod = (data) =>
  new Promise((resolve, reject) => {
    // const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/translation/v3/jobs`;
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/jobs`
    $get(url, data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })

// 开启任务转换
export const postJobConvertor = (bucket_key, object_Key, convertConfig) =>
  new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/jobs`
    // 请求体
    const data = {
      seed: `urn:bimbox.object:${bucket_key}/${object_Key}`,
      job_type: convertConfig.jobType,
      parameters: convertConfig.parameters,
    }
    $post(url, data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })

// 开启三维dwg任务转换
export const postReJobConvertor = (bucket_key, object_Key, job_type) =>
  new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/jobs`
    // 请求job类型
    const data = {
      seed: `urn:bimbox.object:${bucket_key}/${object_Key}`,
      job_type: job_type,
    }
    $post(url, data).then((res) => {
      resolve(res)
    })
  })

//20210329 by wyx
// 开启LOD任务转换
/*export const postJobConvertorForLod = (bucket_key, object_Key) =>
    new Promise((resolve, reject) => {
        console.log('analysisFileType(object_Key)', analysisFileType(object_Key));
        let urlName =
            analysisFileType(object_Key) === 'gim'
                ? 'jobs'
                : analysisFileType(object_Key) === 'obvzip'
                ? 'jobs'
                : 'pcloudjobs';
        let jobType =
            analysisFileType(object_Key) === 'gim'
                ? 'gim-lod'
                : analysisFileType(object_Key) === 'obvzip'
                ? 'obvzip-obv'
                : 'obmx-lod';
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/${urlName}`;
        const data =
            urlName === 'jobs'
                ? {
                      seed: `urn:bimbox.object:${bucket_key}/${object_Key}`,
                      job_type: jobType,
                  }
                : {
                      job_type: jobType,
                      parameters: [
                          {
                              name: 'seed',
                              value: `urn:bimbox.object:${bucket_key}/${object_Key}`,
                          },
                          {
                              key: '-o',
                              value: '{outputFolderPath}',
                          },
                          {
                              key: '-urn',
                              value: '{urn}',
                          },
                      ],
                  };
        $post(url, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });*/

// 获取jobType类型
// export const getAllJobTypes = (bucket_key, object_Key) =>
//   new Promise((resolve, reject) => {
//     const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/translation/v3/filetypes`
//     $get(url).then((res) => {
//       const converters = JSON.parse(JSON.stringify(res).toLowerCase())
//       resolve(converters)
//     })
//   })

// 获取不同格式对应的jobType(除dwg的2d) 参数示例：'rvt','lod'
export const getJobType = (fileFormat, convertWay) =>
  new Promise((resolve, reject) => {
    getConverterTypes()
      .then((res) => {
        let jobType = null
        if (fileFormat === 'dwg') {
          // jobType = `dwg3d-${convertWay}`;
          jobType = `dwg-${convertWay}`
        } else {
          let tempConverters = res.filetypes[fileFormat].converters
          for (let index = 0; index < tempConverters.length; index++) {
            let tempType = tempConverters[index].name.split('-')
            if (tempType[tempType.length - 1] === convertWay) {
              jobType = tempConverters[index].name
            }
          }
        }
        resolve(jobType)
      })
      .catch((err) => {
        reject(err)
      })
  })



// WEBPACK FOOTER //
// ./src/utils/jobUtils.js